import { Injectable } from '@angular/core';
import { StorageKeys } from '../_constants';
import { Settings } from '../_models/settings/settings.model';
import { AgrisLicense } from '../_models/_agrisLicense/agrisLicense.model';

@Injectable({
  providedIn: 'root' 
})
export class StorageServiceProvider {

    constructor() {

    }

    get(key: string) {
        let item = localStorage.getItem(key);
        if (item)
            return JSON.parse(item);

        if (key == StorageKeys.Settings)
            return new Settings();

        if (key == StorageKeys.AgrisLicense)
            return new AgrisLicense();
        return null;
    }

    set(key: string, value: any) {
        if (!value)
            value = null;
        localStorage.setItem(key, JSON.stringify(value));
    }

    getTenantID() {
        let item = this.get(StorageKeys.DataSet);
        if (item && item.TenantID)
            return item.TenantID;
        return null;
    }

    get TenantID() {
        let item = this.get(StorageKeys.DataSet);
        if (item && item.TenantID)
            return item.TenantID;
        return null;
    }

    get AgentID() {
        let item = localStorage.getItem(StorageKeys.AgentId);
        if (item)
            return item;
        return null;
    }

    get AgentType() {
        let item = localStorage.getItem(StorageKeys.AgentType);
        if (item)
            return item;
        return null;
    }

}